import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import debounce from "lodash/debounce";

import { useTableWithAggregation } from "../../../../common/TableWithAggregation/table.js";
import * as _ from "lodash";

import "./BDN.scss";
import { FeatureType } from "../../../../constants/FeatureToggles.js";

import { COLORS, Button, ICONS, Icon, Modal, BUTTONS } from "abs-ui-components";

import AbsModal from "../../../../common/absModal/AbsModal";
import BDNForm from "./BDNForm/BDNForm.js";
import axiosHttp from "../../../../services/interceptor";
import { emitToasterMsg } from "../../../../services/toasterUtility";
import { accessAPIForResponse } from "../../../../services/api-services/api-implementations";

import Loader from "../../../../common/Loader/Loader.js";
import { tranformBdnData, BDN_HEADER } from "./BDNConstants.js";
import { MaterialReactTable } from "material-react-table";
import { ClaimsContext } from "../../../../services/ClaimsService.js";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BDN = () => {
	const { userHasFeature } = useContext(ClaimsContext);
	let currentTime = new Date().toISOString();

	const reportDetails = useSelector((state) => state.reports.selectedReportDetails);
	const reportFlags = useSelector((state) => state.reports.reportFlagDetails);
	const [loading, setLoading] = useState(true);
	const [bdnData, setBdnData] = useState([]);

	const [bdnConfirmDelete, setBdnConfirmDelete] = useState(false);

	const [isGenericErrorsModalOpen, setIsGenericErrorsModalOpen] = useState(false);
	const [globalErrors, setGlobalErrors] = useState([]);

	const [openBDNModal, setOpenBDNModal] = useState(false);
	const [type, setType] = useState("Add");
	const [editBDN, setEditBDN] = useState(null);
	const [disableBtn, setDisableBtn] = useState(false);
	const [rowSelections, setRowSelections] = useState([]);

	const [bdnFields, setBdnFields] = useState(null);
	const [tableInformation, setTableInformation] = useState({ data: [], columns: [] });

	const [showBreadCrumb, setShowBreadCrumb] = useState(() => {
		const storedValue = sessionStorage.getItem("header-footer");
		return storedValue !== null ? JSON.parse(storedValue) : true;
	});

	// Create a debounced setter function
	const debouncedSetHeaderFooterEnabled = debounce((value) => {
		setShowBreadCrumb(value);
	}, 100);

	useEffect(() => {
		const storedValue = sessionStorage.getItem("header-footer");
		if (storedValue !== null) {
			debouncedSetHeaderFooterEnabled(JSON.parse(storedValue));
		}
	}, [debouncedSetHeaderFooterEnabled]);

	useEffect(() => {
		setRowSelections(bdnData.map(() => false));
	}, [bdnData]);

	const getBDNFormData = async () => {
		try {
			const response = await accessAPIForResponse("GetBdnForm", null, [reportDetails?.VesselMstId]);

			setBdnFields(response);
			setOpenBDNModal(true);
		} catch (error) {
			console.error(error);
		}
	};

	const toggleBDNForm = () => {
		setEditBDN(null);
		setType("Add");
		getBDNFormData();
	};

	const closeForm = () => {
		setOpenBDNModal(false);
	};
	const getBdnData = async () => {
		setLoading(true);
		await axiosHttp({
			url: `api/VoyageBdn/GetMepcVoyageBdns?cacheburst=${currentTime}&reportMstId=${reportDetails.ReportMstId}`,
			method: "GET",
		})
			.then((response) => {
				const responseData = response?.data?.slice(0, -2);

				const showValidationMessages = response?.data?.find((item) => item.headerName === "VALIDATION MESSAGES")?.values || {};
				const validationTypes = response?.data?.find((item) => item.headerName === "VALIDATION TYPE")?.values || {};
				if (responseData) {
					setBdnData(responseData || []);

					const tableInfo = tranformBdnData(responseData, showValidationMessages, validationTypes);
					setTableInformation(tableInfo);

					getGlobalError();
				}
				setLoading(false);
			})

			.catch(() => {
				setBdnData([]);
				setLoading(false);
			});
	};

	useEffect(() => {
		getBdnData();
	}, []);
	useEffect(() => {
		setDisableBtn(false);
	}, [openBDNModal]);

	const refetchBDNAndMisStatementErrors = () => {
		getBdnData();
	};

	const handleDeletingBdnRecord = async (selectedDeletBdnRows) => {
		setLoading(true);
		const payload = {
			voyageBdnDtlIds: selectedDeletBdnRows,
		};
		await axiosHttp({
			url: `api/VoyageBdn/DeleteVoyageBdn`,
			method: "POST",
			data: payload,
		})
			.then((res) => {
				if (res && res?.data?.isSuccess) {
					setBdnConfirmDelete(false);
					setLoading(false);
					emitToasterMsg("success", "BDN", "Deleted Successfully");
					getBdnData();
				}
			})
			.catch(() => {
				setBdnConfirmDelete(false);
				setLoading(false);
			});
	};

	const handleExportBdnTable = async () => {
		await accessAPIForResponse("GetVoyageBdnsExcel", null, [reportDetails.ReportMstId])
			.then((response) => {
				if (response) {
					const contentType = response.type;
					if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
						const blob = new Blob([response], {
							type: contentType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", "BDN-Export");
						document.body.appendChild(link);
						link.click();
						emitToasterMsg("success", "BDN-Export.xlsx", "Exported Successfully");
						document.body.removeChild(link);
					}
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const getGlobalError = () => {
		axiosHttp({
			url: `${BASE_URL}api/Report/GetGlobalErrors?reportMstId=${reportDetails.ReportMstId}`,
			method: "GET",
		})
			.then((res) => {
				setGlobalErrors(res.data);
			})
			.catch((error) => {
				emitToasterMsg("error", "BDN", error.response.data.errorMessage);
			});
	};

	const toggleGenericErrors = () => {
		setIsGenericErrorsModalOpen(!isGenericErrorsModalOpen);
	};

	const onRowEditFunction = (row, table) => {
		const data = table.options.data;
		const rowIndex = row.index;
		const rowData = data[rowIndex];
		const rowId = rowData?.Id;
		onEditBDN(rowId);
	};

	const onRowEdit = reportFlags?.VoyagesEnabled ? onRowEditFunction : null;

	const onRowSelection = (selectedRows) => {
		const array = new Array(bdnData.length).fill(false);
		selectedRows.forEach((row) => {
			array[row] = true;
		});

		setRowSelections(array);
	};

	const onEditBDN = async (bdnDtlId) => {
		const vesselId = reportDetails.VesselMstId;
		setType("Edit");
		await axiosHttp
			.get(`api/VoyageBdn/GetBdnForm?vesselMstId=${vesselId}&bdnDtlId=${bdnDtlId}`)
			.then((response) => {
				setBdnFields(response?.data);
				setOpenBDNModal(true);
			})
			.catch((error) => {
				setLoading(false);
				console.error(error);
			});
	};

	const tableData = tableInformation.data;
	const columnsDefinition = tableInformation.columns;
	const tableOptions = {
		actionsDisabled: reportFlags?.VoyagesEnabled !== true,
	};

	const downloadErrorsExcel = async () => {
		await axiosHttp
			.get(`api/Debugger/DebugGlobalErrors?reportMstId=${reportDetails.ReportMstId}`, {
				responseType: "blob"
			})
			.then((response) => {

				const url = window.URL.createObjectURL(new Blob([response.data]));

				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "GlobalErrors.xlsx");

				document.body.appendChild(link);
				link.click();

				link.remove();
				window.URL.revokeObjectURL(url);
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const { tableSettings } = useTableWithAggregation({
		data: tableData,
		columnsDefinition: columnsDefinition,
		onEdit: onRowEdit,
		onRowSelection: onRowSelection,
		options: tableOptions,
	});

	const showMis15DebugLogs = userHasFeature(FeatureType.Mis15DebugLogs);

	return (
		<div className="bdn-wrapper">
			<div className="bdn-table">
				<div className="d-flex justify-content-between fixed-action-btns pr-1 align-items-center mb-3">
					<div className="mt-4 d-flex justify-content-center align-items-center">
						{reportFlags?.VoyagesEnabled && showBreadCrumb && (
							<Button onClick={toggleBDNForm} startIcon={<Icon icon={ICONS.ADD} />} className="ml-2">
								Add New BDN
							</Button>
						)}

						<Button startIcon={<Icon icon="ios_share" />} onClick={handleExportBdnTable} variant="secondary" className="ml-2">
							Export BDN
						</Button>
						{reportFlags?.VoyagesEnabled && showBreadCrumb && (
							<Button
								onClick={() => setBdnConfirmDelete(true)}
								primaryBackgroundColor={COLORS.RED.DARK}
								primaryColor={COLORS.RED.DARK}
								disabled={rowSelections.every((selection) => !selection)}
								startIcon={<Icon icon="delete" />}
								className="ml-2 delete-btn"
							>
								Delete
							</Button>
						)}
					</div>

					<div className="d-flex mt-4">
						{globalErrors.length > 0 && (
							<div
								className="mb-3"
								style={{
									display: "flex",
									alignItems: "center",
									gap: "32px"
								}}
							>
								{showMis15DebugLogs && (<Button
									style={{ marginRight: "48px !important" }}
									variant={BUTTONS.TERTIARY}
									startIcon={<Icon icon={ICONS.DOWNLOAD} />}
									onClick={downloadErrorsExcel}
								>
									Download MIS-15 Logs
								</Button>)}

								<Button
									className="generic-errors-btn"
									variant={BUTTONS.TERTIARY}
									startIcon={<Icon icon={ICONS.WARNING_AMBER} />}
									primaryColor={COLORS.WARNING}
									onClick={toggleGenericErrors}
									disabled={globalErrors.length === 0}
								>
									Global Error(s)
								</Button>
							</div>
						)}
					</div>
				</div>

				{loading ? (
					<div className="loader">
						<Loader />
					</div>
				) : (
					<MaterialReactTable table={tableSettings} />
				)}
			</div>

			<div className="confirmation-modal-container">
				<Modal
					isOpen={bdnConfirmDelete}
					modalHeader
					padding={"70px"}
					headerHeight={"50px"}
					showFooter
					onCloseClickListener={() => {
						setBdnConfirmDelete(false);
					}}
					footer={
						<div className="d-flex justify-content-end fixed-action-btns p-4">
							<Button
								className="delete-btn"
								onClick={() => {
									const allRowIds = Object.keys(
										bdnData.reduce((acc, column) => {
											return {
												...acc,
												...column.values,
											};
										}, {})
									)
										.map((key) => {
											const id = key.split("|")[1];
											return id ? Number(id) : null;
										})
										.filter(Boolean);
									const uniqueRowIds = allRowIds.filter((id) => id !== 0);
									const selectedRows = uniqueRowIds.filter((id, index) => rowSelections[index]);
									const idsToDelete = uniqueRowIds.filter((id) => selectedRows.includes(id));
									if (idsToDelete.length > 0) {
										handleDeletingBdnRecord(idsToDelete);
										tableSettings.resetRowSelection();
									}
								}}
								primaryColor={COLORS.RED.DARK}
								primaryBackgroundColor={COLORS.RED.LIGHT}
							>
								Delete
							</Button>
							<Button
								className="modal-cancel-btn"
								onClick={() => {
									setBdnConfirmDelete(false);
								}}
							>
								Cancel
							</Button>
						</div>
					}
				>
					<div>Are you sure you want to delete the BDN?</div>
				</Modal>

				<AbsModal isOpen={isGenericErrorsModalOpen} title="Global Error(s)" onClose={setIsGenericErrorsModalOpen} close={toggleGenericErrors}>
					{isGenericErrorsModalOpen && (
						<div className="generic-errors-wrapper">
							<label className="generic-errors-header">Error(s): </label>

							<ul className="error-list-wrapper">
								{globalErrors &&
									globalErrors.map((item) => {
										return <li>{item}</li>;
									})}
							</ul>
							<Button className="generic-errors-close-btn" variant="secondary" onClick={toggleGenericErrors}>
								Close
							</Button>
						</div>
					)}
				</AbsModal>
			</div>

			<div className="bdn-modal">
				<AbsModal isOpen={openBDNModal} title={`${type} ${BDN_HEADER}`} onClose={setOpenBDNModal} close={closeForm}>
					{openBDNModal && (
						<BDNForm
							editBDN={editBDN}
							bdn_data={bdnFields}
							type={type}
							onRefetchBDNAndMisStateMentErrs={refetchBDNAndMisStatementErrors}
							onClose={closeForm}
							disableBtn={disableBtn}
							setDisableBtn={setDisableBtn}
						/>
					)}
				</AbsModal>
			</div>
		</div>
	);
};

export default BDN;
